import AudioManager from "../../Shared/AudioManager";

const {ccclass, property} = cc._decorator;

@ccclass
export default class TaskDetail extends cc.Component {

    @property(cc.Node)
    content: cc.Node = null;
    // @property([cc.Node])
    // barArr: cc.Node[] = [];



    start () {

    }

    updateUI(param){
        this.content.getChildByName("labName").getComponent(cc.Label).string = param.taskName;
        this.content.getChildByName("labTime").getComponent(cc.Label).string = param.taskTime;

        this.content.getChildByName("labContent").getComponent(cc.Label).string = param.taskContent;
        this.content.getChildByName("labDetail").getComponent(cc.Label).string = param.taskDetail;
        //let progressArr = param.alreadyMoney  || [];
        // if (param.taskHandleStatus === -1 && progressArr[0].targetMoney) {//状态为-1 才有进度
        //     if (progressArr.length === 1){
        //         this.barArr[1].active = false;
        //     }
        //     for (let i = 0;i < progressArr.length;i++){
        //         this.barArr[i].active = true;
        //         this.barArr[i].getChildByName("planName").getComponent(cc.Label).string = progressArr[i].planName;
        //         this.barArr[i].getChildByName("nameNow").getComponent(cc.Label).string = progressArr[i].alreadyMoney;
        //         this.barArr[i].getChildByName("nameTask").getComponent(cc.Label).string = "/" + progressArr[i].targetMoney;
        //         let progress = progressArr[i].alreadyMoney/progressArr[i].targetMoney;
        //         this.barArr[i].getChildByName("progressBar").getComponent(cc.ProgressBar).progress = progress;
        //     }
        // } else {
        //     for (let i = 0;i < progressArr.length;i++){
        //         this.barArr[i].active = true;
        //         this.barArr[i].getChildByName("planName").getComponent(cc.Label).string = progressArr[i].planName;
        //         this.barArr[i].getChildByName("nameNow").getComponent(cc.Label).string = "";
        //         this.barArr[i].getChildByName("nameTask").getComponent(cc.Label).string = "";
        //         this.barArr[i].getChildByName("progressBar").getComponent(cc.ProgressBar).progress = 1;
        //     }
        // }
    }

    onBtnClose(){
        AudioManager.playSound("close")
        this.node.destroy();
    }


}
